export const API_URL  = "https://www.tsdevcut.co.za/wp-json/wp/v2/";
export const API_CUST = "https://www.tsdevcut.co.za/wp-json/ts/clansmen/people/v1/";
export const SMALLER_PROCESS = "https://cjmarketing.co/image_directory/loading.gif";